import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { useState } from 'react';

interface FeedbackParams {
  bookId?: string;
  bookTitle: string;
  bookAuthor: string;
  isbn13?: string;
  isbn10?: string;
  feedbackType: 'upvote' | 'downvote' | 'dismissed';
  recommendationReason?: string;
  promptUsed?: string;
  sessionId?: string;
}

export function useRecommendationFeedback() {
  const [loading, setLoading] = useState(false);

  const submitFeedback = async (params: FeedbackParams) => {
    setLoading(true);
    
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        toast.error('You must be logged in to provide feedback');
        return { success: false };
      }

      const { error } = await supabase
        .from('recommendation_feedback')
        .insert({
          user_id: user.id,
          book_id: params.bookId,
          book_title: params.bookTitle,
          book_author: params.bookAuthor,
          isbn13: params.isbn13,
          isbn10: params.isbn10,
          feedback_type: params.feedbackType,
          recommendation_reason: params.recommendationReason,
          prompt_used: params.promptUsed,
          session_id: params.sessionId,
        });

      if (error) throw error;

      if (params.feedbackType === 'downvote' || params.feedbackType === 'dismissed') {
        toast.success('Got it!', {
          description: 'We won\'t recommend this book again. Our AI will learn from your feedback.',
        });
      }

      return { success: true };
    } catch (error) {
      console.error('Error submitting feedback:', error);
      toast.error('Failed to submit feedback');
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return { submitFeedback, loading };
}
